import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IModalState {
  activeModals: string[],
}

const initialState: IModalState = {
  activeModals: [],
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    closeModal: (state, action: PayloadAction<string>) => {
      state.activeModals = state.activeModals.filter((modal) => modal !== action.payload);
    },
    openModal: (state, action: PayloadAction<string>) => {
      state.activeModals.push(action.payload);
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
